import React from 'react'
import { ImageUpload } from '../ImageUpload'
import FrameSizeSelection from '../FrameSizeSelection'
import ProductAttributesSelection from '../ProductAttributesSelection'
import { CartSummarize, CartModal } from '../Cart'
import SubmitButton from '../SubmitButton'
import { OrderFormContext } from '../../contexts'
import useCalculateTotalPrice from '../../hooks/useCalculateTotalPrice'
import { Success, Loading } from '../Status'
import ShapeSelection from '../ShapeSelection'
import config from '../../config'
import AuthNotice from './AuthNotice'
import BoxInfo from './BoxInfo'
import { DoubleLeftOutlined } from '@ant-design/icons'
import classNames from 'classnames'

const OrderForm = () => {
  useCalculateTotalPrice()

  const {
    isLoading,
    isLoadingAttribute,
    frameSize,
    submitFormSuccess,
    loadOrderFormData,
    loadProductAttributes,
    box,
    isExtendedUploaderArea,
    setIsExtendedUploaderArea,
  } = React.useContext(OrderFormContext)

  React.useEffect(() => {
    loadOrderFormData()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  React.useEffect(() => {
    frameSize && loadProductAttributes()

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [frameSize])

  const isUserLoggedIn = parseInt(config.userId) > 0

  return (
    <div className="OrderJourneyMain">
      <Success visible={submitFormSuccess}/>
      <Loading visible={isLoading}/>

      {!isLoading && !submitFormSuccess && (
        <>
          <div className='flex justify-between flex-col lg:flex-row'>
            <div className={classNames(
              isExtendedUploaderArea ? 'lg:w-2/3' : 'lg:w-1/2',
            )} >
              {isUserLoggedIn
                ? <ImageUpload />
                : <AuthNotice />
              }
            </div>
            <div className={classNames(
              isExtendedUploaderArea ? 'lg:w-1/3' : 'lg:w-1/2',
            )}>
              <div className='flex gap-1'>
                <div style={{
                  maxHeight: 'calc(100vh - 3rem)',
                }} className='flex items-center'>
                  <div style={{
                    borderRight: '1px solid #ccc',
                  }} className='mr-3 h-32 flex items-center justify-center'>
                    <button
                      onClick={() => setIsExtendedUploaderArea(prevState => !prevState)}
                      style={{ transform: 'translateX(50%)' }}
                      className={classNames('py-3 bg-white',)}>
                      <DoubleLeftOutlined
                        className={classNames(
                          'transition-opacity opacity-50 hover:opacity-100 hover:scale-110',
                        )}
                        style={{ transform: isExtendedUploaderArea ? '' : 'rotate(180deg)' }}
                      />
                    </button>
                  </div>
                </div>
                <div>
                  <CartSummarize/>
                  <ShapeSelection/>
                  <FrameSizeSelection/>
                  <Loading visible={isLoadingAttribute}/>
                  {!isLoadingAttribute && <ProductAttributesSelection/>}
                  {box && <BoxInfo box={box}/>}
                  <SubmitButton/>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
      <CartModal/>
    </div>
  )
}

export default OrderForm
